<template>
  <div>
    <wc-data-box
      :title='$store.state.icons.modules.labour.title'
      :titleIcon='$store.state.icons.modules.labour.icon'
      :titleIconColor='$store.state.icons.modules.labour.color'
    >
      <template v-slot:toolbarButtons>
        <span
          v-if='labour.length'
          class='caption mr-2 grey--text font-italic'
          style='letter-spacing: -0.4px !important;'
        >
          {{ ($vuetify.breakpoint.smAndDown ? 'Tap' : 'Click') + ' row to edit' }}
        </span>
        <v-btn small color='primary' width='76px' depressed @click='openLabour()'>
          <v-icon small left>mdi-plus</v-icon>
        Add
      </v-btn>
      </template>
      <v-simple-table outlined dense>
        <tbody>
          <tr v-if='!labour.length'>
            <td class='text-left grey--text'>None...</td>
          </tr>
          <tr v-else v-for='(entry, index) in labour' :key='index'>
            <td class='text-left pr-0' @click='editLabour(entry)'>
              <wc-avatar :profile='entry.added_by_obj'></wc-avatar>
              <span class='font-weight-bold ml-2'>{{ entry.date | shortDateNoYear }}</span>
              <span class='font-weight-bold ml-1 caption'>{{ '(' + entry.num_mins + 'mins)' }}</span>
              {{ '- ' + entry.task_completed + (entry.is_warranty ? ' (wrty)' : '') }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </wc-data-box>

<!-- LABOUR DIALOG -->
    <wc-dialog
      :showDialog='showLabourDialog'
      title='Add Labour'
      :disableButtons='!isLabourFormValid'
      @cancel='showLabourDialog = false'
      @save='updateLabour'
      width='350'
    >
      <v-form ref='form' v-model='isLabourFormValid'>
        <v-row>
          <v-col cols='12'>
            <v-textarea
              ref='description'
              v-model='labourCopy.task_completed'
              label='Task Completed'
              :rules='[rules.required]'
              outlined
              auto-grow
              hint='Be descriptive so the office understands.'
              persistent-hint
            ></v-textarea>
            <v-combobox
              type='number'
              v-model='labourCopy.num_workers'
              label='Number of Workers'
              :items='numberOfWorkersOptions'
              :rules='[rules.posInt]'
              hint='choose a value, or enter one'
              persistent-hint
            ></v-combobox>
            <v-combobox
              type='number'
              v-model='labourCopy.num_mins'
              label='Number of Minutes'
              :items='numberOfMinutesOptions'
              :rules='[rules.posInt, localRules.minTen]'
              hint='(minimum 5 mins)'
              persistent-hint
              @change='validateInputs'
            ></v-combobox>
            <v-checkbox
              class='mb-n4'
              label='Is this warranty?'
              v-model='labourCopy.is_warranty'
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-form>
      <template v-slot:dialog-actions v-if='labourCopy.id'>
        <v-btn small depressed color='error' @click='deleteLabour()'>
          Delete
        </v-btn>
      </template>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'fc-labour',
  mixins: [formRules],
  props: {
    wo: {
      required: true
    },
    labour: {
      required: true
    },
  },
  data: () => ({
    isLabourFormValid: false,
    showLabourDialog: false,
    numberOfWorkersOptions: ["1","2"],
    numberOfMinutesOptions: ["5", "10","15","20","30"],
    labourCopy: {},
    labourItemReset: {
      task_completed: '',
      num_workers: '',
      num_mins: '',
      is_warranty: false,
      added_by: null,
      labour_type: null,
      date: null,
    },
  }),
  computed: {
    localRules() {
      return {
        minTen: (value) => {
          if (value) {
            return value.toString() > 4 || 'minimum 5 minutes'
          }
          return true
        },
      }
    }
  },
  methods: {
    editLabour(entry) { 
      this.labourCopy = _.cloneDeep(entry)
      this.showLabourDialog = true
    },
    openLabour () {
      this.labourCopy = _.cloneDeep(this.labourItemReset)
      // Adding default labour type EM - Mar 1, 2021
      this.labourCopy.labour_type = this.wo.wo_type_obj.default_labour_type
      this.showLabourDialog = true
      setTimeout(() => {
        this.$refs.form.resetValidation()
      }, 50)
      setTimeout(() => {
        // this doesn't actually bring the keyboard out on ios.  unsure if solvable at the moment. -MJ
        // might want to try nextTick instead of setTimeout
        this.$refs.description.focus()
      }, 100)
    },
    updateLabour () {
      this.$emit('updateLabour', this.labourCopy)
      this.showLabourDialog = false
    },
    deleteLabour () {
      this.$emit('deleteLabour', this.labourCopy.id)
      this.showLabourDialog = false
    },
    validateInputs() {
      this.$refs.form.validate()
    }
  }
}
</script>

<style scoped>

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
-webkit-appearance: none;
margin: 0;
}

</style>